import styled from 'styled-components'
import { zIndex } from '../../constants/zIndex'
import { Logo as BlLogo } from '../../elements/Icons/Logo'
import { Link } from '../../elements/Link'
import { Type } from '../../elements/Typography/Typography'
import { mixins } from '../../utils/mixins'
import { spacing } from 'ui-primitives/src/utils/spacing'
import { colors } from '../../constants/colors'
import { media } from 'ui-primitives/src/utils/media'

export const Logo = styled(BlLogo)`
  margin-bottom:  ${spacing[2.5]};
  width: 130px;
`

export const Form = styled.form`
  position: relative;
`

export const ErrorMessage = styled.div`
  position: absolute;
  bottom:  ${spacing[-1.5]};
`

export const GroupHeader = styled(Type)`
  padding-top:  ${spacing[2]};
  ${media.md`
    padding-top: 0;
  `}
`

export const Container = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: auto;
  color: var(--color-text);

  ${media.md`
    grid-template-columns: 25% 1fr;
    grid-template-rows: 1fr 72px;
  `};
`

export const StyledLink = styled(Link)`
  display: inline;
  &:hover {
    text-decoration: underline;
  }
`

export const ContactBox = styled.div`
  background: var(--color-fillPrimary);
  color: var(--color-text);
  display: flex;
  flex-direction: column;
  align-items: center;
  ${mixins.siteGutter()};

  padding-top:  ${spacing[3]};
  padding-bottom:  ${spacing[3]};
  z-index: ${zIndex.above};

  ${media.md`
    grid-column: 1 / 2;
    grid-row: 1 /3;
    padding:  ${spacing[3]} ${spacing[3.5]} ${spacing[4.5]};
  `};
`

export const Content = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  background: var(--color-buttonDisabled);
  color: var(--color-text);

  ${mixins.siteGutter()};

  padding-top:  ${spacing[1.5]};
  padding-bottom:  ${spacing[3]};

  ${media.md`
    grid-template-columns: repeat(3, minmax(0, 1fr));
    grid-column: 2 / 3;
    grid-row: 1 /2;
    padding:  ${spacing[3]} ${spacing[3.5]} ${spacing[2]};
  `};
`

export const SignupWrap = styled.div`
  button > p {
    font-size: 16px;
  }
`

export const LogoList = styled.div`
  margin-top: ${spacing[0.5]};
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  gap: ${spacing[1]};

  ${media.md`
    flex-wrap: nowrap;
    overflow-x: hidden;
  `};
`

export const LogoWrap = styled.div` 
  height: 75px;
  position: relative;

  & svg {
    height: 100%;
    fill: var(--color-text);
  };
  
  ${media.md`
    height: ${spacing[5]};  
  `};
`

export const Bottom = styled.div`
  background: var(--color-background);
  color: var(--color-text);
  align-items: center;
  display: grid;
  grid-template-columns: 1fr;
  row-gap:  ${spacing[1.5]};

  ${mixins.siteGutter()};

  padding-top:  ${spacing[3]};
  padding-bottom:  ${spacing[8]};

  ${media.md`
    grid-template-columns: repeat(3, 1fr);
    grid-column: 2 / 3;
    grid-row: 2 /3;
    padding:  0 ${spacing[3.5]};
  `};
`

export const Group = styled.div`
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  flex: 0 1 50%;
  gap:  ${spacing[0.5]};

  & + & {
    padding-bottom:  ${spacing[2]};
  }

  ${media.md`
    & + & {
      padding-bottom: 0;
    }
  `};
`

export const Secondary = styled.div`
  margin-top: ${spacing[0.5]};

  ${StyledLink} {
    color: lighten(0.2, ${colors.dark});
  }
`

export const IconLink = styled(Link)`
  align-items: center;
  display: flex;
`
export const selectorWrapper = styled.div`
  position: relative;
`
